import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';


@Component({
  selector: 'app-changes-prevention-dialog',
  templateUrl: './ui-changes-prevention-dialog.component.html',
  styleUrls: ['./ui-changes-prevention-dialog.component.scss']
})

export class UiChangesPreventionDialogComponent implements OnInit {

  @Output() userActions: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {

  }

  onContinue() {
  this.userActions.emit({data: true});
  }


  onCancel() {
    this.userActions.emit({data: false});
  }


}
